module.exports = __webpack_public_path__ + "img/yuxing-topImg.4d8395d1.jpeg";